import { TypeOptions } from "i18next";
import { UserDto } from "../../api/data-contracts";
import { FormComponentConfig } from "../interfaces";

export type ValuesArray<T> = T[keyof T];

export type ApiServiceCall = (args?: any) => Promise<any>; // TODO fix

export type HookFormConfig = Record<string, FormComponentConfig>;

export enum FieldTypes {
  string = "string",
  date = "date",
  number = "number",
  lookup = "lookup",
  search = "search",
}

export enum FormMode {
  add = "add",
  edit = "edit",
}

export enum UserRoles {
  admin = "ADMIN",
  sysAdmin = "SYSADM",
  user = "USER",
  guest = "GUEST",
  opr = "OPR",
}

export enum BranchType {
  hostel = "HOSTEL",
  dayCare = "DAY_CARE",
  grooming = "GROOMING",
  vet = "VETERINARY",
}

export enum AnimalSize {
  small = "Small",
  medium = "Medium",
  large = "Large",
}

export enum ActionType {
  new = "new",
  update = "update",
  delete = "delete",
}

export type UserRoleValues = ValuesArray<typeof UserRoles>;

export type UserWithRoleCheck = UserDto & {
  isUserRole: (userRole: UserRoleValues) => boolean;
};

export type TranslationFunc = TypeOptions["returnNull"] extends true // TranslationFunc is t('some.translation.string')
  ? null
  : never;
